module.exports = __webpack_public_path__ + "img/product-details-3.be4f5552.svg";